import { langList, getLang as i18nGetLang } from '@cainiaofe/cn-i18n';
export function getLang(lang) {
    // 当传入 false 固定返回中文
    if (lang === false) {
        return 'zh-CN';
    }
    // 当传入 true 返回系统语种
    if (lang === true) {
        return i18nGetLang();
    }
    // 当未传入返回系统语种
    if (!lang) {
        return i18nGetLang();
    }
    // 当传入合法语种，返回语种
    const hasLang = langList.find((i) => i.value === lang);
    if (hasLang) {
        return lang;
    }
    // 兜底返回系统语种
    return i18nGetLang();
}
